import { connect } from 'react-redux'

import { handleSeatClick } from '../../../../reducer'

const mapStateToProps = (state) => ({
    basket: state?.components?.basket?.data ?? null,
})

const hocConnect = (InnerComponent) => connect(mapStateToProps, { handleSeatClick })(InnerComponent)

export default hocConnect
